import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OrganismModel } from '../partners/organisms/organism.model';
import { MasterService } from 'src/app/masters/master.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { AddPatientComponent } from './add-patient/add-patient.component';
import { PatientService } from './patient.service';
import { LoaderService } from '../common/loader.service';
import * as CommonConstants from '../utils/common.constants';
import { formatDate } from '@angular/common';
import { SharedService } from '../utils/shared.service';


@Component({
  selector: 'app-patients',
  templateUrl: './patients.component.html',
  styleUrls: ['./patients.component.scss']
})
export class PatientsComponent implements OnInit {

  organisms: OrganismModel[];
  townList: any = [];
  countryList: any = [];
  genderList;
  // columnDefs: any[];
  rowData: any[];
  patientSearchForm: FormGroup;
  addPatient;
  toggleColumn: boolean = true;
  partnerList;
  nationalityList;
  addressTypeList=[];
  countries=[];
  towns=[];
  newPatient: AddPatientComponent;
  searchCollapse = true;
  priv_addPatient: boolean;

  @ViewChild(AddPatientComponent, { static: true }) set Content(newPatientRef) {
    this.newPatient = newPatientRef;
  }
  constructor(public router: Router, private masterService: MasterService, private formBuilder: FormBuilder
    , private patientService: PatientService, private loaderService: LoaderService, private route: ActivatedRoute,private sharedService:SharedService) {

    this.getFromGroup();
  }


  ngOnInit() {
    this.priv_addPatient=this.sharedService.hasPrivilege(CommonConstants.PRIV_ADD_PATIENT);
    this.loadMasterData();
    let masterData = this.route.snapshot.data.masterData;
    if (masterData) {
      this.organisms = masterData.organisms;
      this.genderList = masterData.genderList["result"];
    }
  }

  loadMasterData() {
    this.masterService.getOrganisms().subscribe(response => {
      if (response && response['result']) {
        this.organisms = response['result'];
      }
    })
    this.masterService.getGenderList();
    this.masterService.genderList.subscribe(value => {
      this.genderList = value;
    });

    this.masterService.getTown().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.townList = response['result'];
      }
    });

    this.masterService.getCountry().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.countryList = response['result'];
      }
    });
    this.masterService.getPartners();
    this.masterService.partnerList.subscribe(value => {
      this.partnerList = value;
    });

    this.masterService.getNationalitList();
    this.masterService.nationailityList.subscribe(value => {
      this.nationalityList = value;
    });
    this.masterService.getAddressTypes().subscribe(response => {
      if (response['code'] == 'S0000') {
        this.addressTypeList = response['result'];
      }
    });
    this.masterService.getCountry().subscribe(response => {
      if (response && response['result']) {
        this.countries = response['result'];

      }
    })
    this.masterService.getTown().subscribe(response => {
      if (response && response['result']) {
        this.towns = response['result'];
      }
    })
    setTimeout(() => {
      this.searchPatient();
    }, 1000);
  }

  private getFromGroup() {
    this.patientSearchForm = this.formBuilder.group({
      'orgsmId': new FormControl(),
      'cotryIdNationality': new FormControl(),
      'townId': new FormControl(),
      'persoVaFirstname': new FormControl(),
      'persoVaLastname': new FormControl(),
      'patientNumber': new FormControl()
    })
  }

  searchPatient() {
    this.loaderService.display(true);
    this.patientService.getPatients(this.patientSearchForm.value).subscribe(response => {
      this.loaderService.display(false);
      let result = response['result'];
      if (result) {
        result = result.map(item => ({
          ...item,
          orgName: item.orgsmId ? this.organisms.find(obj => obj.orgsmId === item.orgsmId).compaVaNameEn : null,
          genderName:item.gendeCode ? this.genderList.reduce(function(prev, curr) { return (curr.genderId === +item.gendeCode) ? curr.description : prev; }, null) : null,
          persoDtBirthDate : item.persoDtBirthDate?formatDate(item.persoDtBirthDate, 'dd/MM/yyyy', 'en-US'): null,
          nationalityName: item.cotryIdNationality ? this.nationalityList.find(obj => obj.cotryId === item.cotryIdNationality).cotryVaNationalityEn : null
        }))
      }
      this.rowData = result;
    }, error => {
      this.loaderService.display(false);
    })
  }

  addNewPatient() {
    this.router.navigate(['addPatient']);
  }


  onRowClicked(event: any) {
    this.addPatient = true;
    this.toggleColumn = false;
    this.searchCollapse = false;
    this.loadPatientById(event);
    this.newPatient.addPatientTitle = false;
    this.newPatient.editPatientTitle = true;
  }

  loadPatientById(event: any) {
    this.loaderService.display(true);
    this.newPatient.setPartners();
    this.newPatient.url='';
    this.newPatient.selectedMedfiId='';
    this.patientService.getPatientById(event.data.patieId).subscribe(res => {
      this.loaderService.display(false);
      if (res['code'] == 'S0000') {
        let response = res['result'];
        this.newPatient.patieId=response["patieId"];
        this.newPatient.patientForm.patchValue({
          "patieId": response["patieId"],
          "civilCode": +response["civilCode"],
          "cotryIdNationality": response["cotryIdNationality"],
          "cotryIdResidence": response["cotryIdResidence"],
          "gendeCode": +response["gendeCode"],
          "mastaCode": response["mastaCode"],
          "orgsmId": response["orgsmId"],
          "patieNuNumberChildren": response["patieNuNumberChildren"],
          "patieNuNumberSpouse": response["patieNuNumberSpouse"],
          "patieVaEmployment": response["patieVaEmployment"],
          "patieVaPassportNumber": response["patieVaPassportNumber"],
          "patientNumber": response["patientNumber"],
          "persoDtBirthDate": response["persoDtBirthDate"],
          "persoVaEmail1": response["persoVaEmail1"],
          "persoVaEmail2": response["persoVaEmail2"],
          "persoVaFirstname": response["persoVaFirstname"],
          "persoVaFirstnameEn": response["persoVaFirstnameEn"],
          //"persoVaHomePhone": response["persoVaHomePhone"],
          "persoVaLastname": response["persoVaLastname"],
          "persoVaLastnameEn": response["persoVaLastnameEn"],
         // "persoVaMobilePhone1": this.sharedService.getInternationPhoneFormat(response["persoVaMobilePhone1"]),
          //"persoVaMobilePhone2": response["persoVaMobilePhone2"],
          "persoVaNickname": response["persoVaNickname"],
          "persoVaReligion": response["persoVaReligion"],
          "persoVaSecondName": response["persoVaSecondName"],
          "persoVaSecondNameEn": response["persoVaSecondNameEn"],
          "persoVaThirdName": response["persoVaThirdName"],
          "persoVaThirdNameEn": response["persoVaThirdNameEn"],
         // "persoVaWorkFax": response["persoVaWorkFax"],
         // "persoVaWorkPhone": response["persoVaWorkPhone"],
          "prfesId": response["prfesId"],
          "staRecCode": response["staRecCode"],
          "patieNationalIdNum": response["patieNationalIdNum"],
        });
        this.newPatient.phoneNos.forEach(phone => {
            phone.phone=phone.getInternationPhoneFormat(response[phone.type]);
        })
        let responseObj = response["administrations"];
        responseObj =  responseObj.map(item =>({
          partnerid: item.adminId,
          partnername : this.newPatient.administrationList.find(pItem => pItem.partnerid == item.adminId).partnername,
        }))
        this.newPatient.selectedAdminstrationItems=[];
        this.newPatient.patientAdminstrationList = responseObj;
        for(let obj of responseObj){
          this.newPatient.administrationList= this.newPatient.administrationList.filter(admin => admin.partnerid!=obj.partnerid && admin.partnername!=obj.partnername);
        }
        responseObj = response["financials"];
        responseObj =  responseObj.map(item =>({
          partnerid: item.finanId,
          partnername : this.newPatient.financialList.find(pItem => pItem.partnerid == item.finanId).partnername,
        }))
        this.newPatient.selectedFinancialItems=[];
        this.newPatient.patientFinanciaFulllList = responseObj;
        /* for(let obj of responseObj){
          this.newPatient.financialList= this.newPatient.financialList.filter(finac => finac.partnerid!=obj.partnerid && finac.partnername!=obj.partnername);
        } */
        responseObj = response["logistics"];
        responseObj =  responseObj.map(item =>({
          partnerid: item.logistId,
          partnername : this.newPatient.logisticList.find(pItem => pItem.partnerid == item.logistId).partnername,
        }))
        this.newPatient.selectedLogisticItems=[];
        this.newPatient.patientLogisticFullList = responseObj;
        //Remove fro master List
       /*  for(let obj of responseObj){
          this.newPatient.logisticList= this.newPatient.logisticList.filter(logist => logist.partnerid!=obj.partnerid && logist.partnername!=obj.partnername);
        } */
         this.newPatient.patientAddress.addressList = response.address.map(item => ({
          ...item,
          addressType: item.typeId ? this.addressTypeList.find(obj => +obj.typeId === +item.typeId).description: null,
          townName: item.townId ? this.towns.find(town => town.townId === item.townId).townDescEn : null,
          countryName: item.cotryId ? this.countries.find(country => country.cotryId === item.cotryId).cotryDescEn : null
        }));
        this.newPatient.patientContact.employeeList = JSON.parse(JSON.stringify(response.employee));
        this.newPatient.medicalFiles=response["medicalFiles"];
        this.newPatient.fileUpload.medicalDocuments= response["patientDocs"].map(item => ({
          ...item,
          fileName: this.newPatient.fileUpload.fetchFileName(item.meddoVaPath),
          // docType :   item.dotypId ? this.docTypes.find(obj => obj.dotypId === item.dotypId).dotypDescriptionEn : null
        }));
        this.newPatient.patientLogisticList =[];
        this.newPatient.patientFinancialList = [];
        //this.newPatient.fileUpload.medicalDocuments=[];
         //this.newPatient.fileUpload.medicalDocuments.push(medicalDocuments);
        this.newPatient.getAgeCategory();
      }
      
    },
      error => {
        this.loaderService.display(false);
      })

      this.masterService.getPatientImageById(CommonConstants.PATIENT,event.data.patieId).subscribe(res => {
        if (res['code'] == 'S0000') {
          let response = res['result'];
          if (response['image'] != null) {
            this.newPatient.url = 'data:image/png;base64,' + response['image'];
          } else {
            this.newPatient.url = '';
          }
        } else {
          this.newPatient.url = '';
        }

      })
  }
  reset(){
    this.patientSearchForm.reset();
    this.hideRightDiv();
    this.rowData=[];
  }
  hideRightDiv(){
    this.addPatient = false;
    this.toggleColumn = true;
    this.searchCollapse = true;
  }
}
